import {
  PluginEquifaxIdMatrixForm,
  PluginEquifaxIdMatrixFormResponse,
} from '../../../types/plugins';
import { ConstructPost } from '../../types/ConstructPost';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { PLUGIN_BASE_PATH } from '../constants/pluginBasePath';

export const runEquifaxIdMatrixForm = (
  constructPost: ConstructPost,
  data: PluginEquifaxIdMatrixForm,
): Promise<
  NonPaginatedResponse<PluginEquifaxIdMatrixFormResponse> | undefined
> =>
  constructPost<NonPaginatedResponse<PluginEquifaxIdMatrixFormResponse>>(
    `${PLUGIN_BASE_PATH}/equifax-id-matrix-form`,
    { data },
  );
